<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ $t(`${namespace}.title`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-tooltip
        v-if="hasRole('companyGroup', 'ROLE_PUT_COMPANYGROUP')"
        slot="append"
        top
      >
        <v-btn
          color="gray-6"
          class="mx-0"
          slot="activator"
          flat
          icon
          @click="$router.push({
            name: 'CompanyGroup',
            params: {
              type: 'editar',
              id: data.companyGroup.id
            }
          })"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <span>{{ $t('Common.edit') }}</span>
      </v-tooltip>

      <v-tooltip
        v-if="hasRole('companyGroup', 'ROLE_DELETE_COMPANYGROUP')"
        slot="append"
        top
      >
        <v-btn
          color="gray-6"
          class="mx-0"
          slot="activator"
          flat
          icon
          @click="openSingleDeleteDialog"
        >
          <v-icon>delete</v-icon>
        </v-btn>
        <span>{{ $t('Common.delete') }}</span>
      </v-tooltip>

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <RemoveCompanyGroupDialog
      :visible="singleDeleteDialog"
      :companyGroup="data.companyGroup"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import RemoveCompanyGroupDialog from 'components/company/companiesGroup/RemoveCompanyGroupDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    action: {
      type: String,
      required: true
    },

    data: {
      type: Object,
      required: true
    }
  },
  components: {
    RemoveCompanyGroupDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.companyGroup.header',
      singleDeleteDialog: false
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
